var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "button-container" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-add-feature",
              attrs: { type: "success" },
              on: {
                click: function ($event) {
                  return _vm.handleCreate()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-plus" }),
              _vm._v(" Add New Feature "),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            data: _vm.list,
            "element-loading-text": "Loading...",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "ID", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.id) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Feature Key", align: "center", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: { type: _vm.getFeatureTagType(row.featureKey) },
                      },
                      [_vm._v(" " + _vm._s(row.featureKey) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Name", align: "center", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.name) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Description",
              align: "center",
              "min-width": "250",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.description) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Type", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.configJson && row.configJson.type
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", size: "small" } },
                          [_vm._v(" " + _vm._s(row.configJson.type) + " ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Device Required", align: "center", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.configJson && row.configJson.deviceRequired
                      ? _c("i", {
                          staticClass: "el-icon-check",
                          staticStyle: { color: "green", "font-size": "18px" },
                        })
                      : _c("i", {
                          staticClass: "el-icon-close",
                          staticStyle: { color: "red", "font-size": "18px" },
                        }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Status", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleStatusChange(row)
                        },
                      },
                      model: {
                        value: row.isActive,
                        callback: function ($$v) {
                          _vm.$set(row, "isActive", $$v)
                        },
                        expression: "row.isActive",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Actions", align: "center", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "mini",
                          icon: "el-icon-edit",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      },
                      [_vm._v(" Edit ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "info",
                          size: "mini",
                          icon: "el-icon-view",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleView(row)
                          },
                        },
                      },
                      [_vm._v(" View ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogFormVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Feature Key", prop: "featureKey" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "e.g., voice_assistant",
                      disabled: _vm.dialogStatus === "update",
                    },
                    model: {
                      value: _vm.formData.featureKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "featureKey", $$v)
                      },
                      expression: "formData.featureKey",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Name", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "e.g., Voice Assistant" },
                    model: {
                      value: _vm.formData.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Description", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "Feature description",
                    },
                    model: {
                      value: _vm.formData.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "description", $$v)
                      },
                      expression: "formData.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Type", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "Select type" },
                      model: {
                        value: _vm.formData.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "type", $$v)
                        },
                        expression: "formData.type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: "Permanent (No expiration)",
                          value: "permanent",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Time Limited (Has end date)",
                          value: "time_limited",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Subscription (Renewable)",
                          value: "subscription",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Consumable (One-time use)",
                          value: "consumable",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formData.type === "time_limited" ||
              _vm.formData.type === "subscription"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Default Duration" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 1, max: 3650, placeholder: "365" },
                        model: {
                          value: _vm.formData.defaultDurationDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "defaultDurationDays", $$v)
                          },
                          expression: "formData.defaultDurationDays",
                        },
                      }),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#999",
                            "font-size": "12px",
                            "margin-left": "10px",
                          },
                        },
                        [_vm._v("days")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formData.type === "time_limited" ||
              _vm.formData.type === "subscription"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Reminder Days" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            multiple: "",
                            placeholder: "Select reminder days",
                          },
                          model: {
                            value: _vm.formData.reminderDays,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "reminderDays", $$v)
                            },
                            expression: "formData.reminderDays",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "1 day before", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "3 days before", value: 3 },
                          }),
                          _c("el-option", {
                            attrs: { label: "7 days before", value: 7 },
                          }),
                          _c("el-option", {
                            attrs: { label: "14 days before", value: 14 },
                          }),
                          _c("el-option", {
                            attrs: { label: "30 days before", value: 30 },
                          }),
                          _c("el-option", {
                            attrs: { label: "60 days before", value: 60 },
                          }),
                          _c("el-option", {
                            attrs: { label: "90 days before", value: 90 },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        { staticStyle: { color: "#999", "font-size": "12px" } },
                        [_vm._v("Send reminders before expiration")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "Platforms" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.formData.platforms,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "platforms", $$v)
                        },
                        expression: "formData.platforms",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "ios" } }, [
                        _vm._v("iOS"),
                      ]),
                      _c("el-checkbox", { attrs: { label: "android" } }, [
                        _vm._v("Android"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("Device Settings"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Device Required" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.formData.deviceRequired,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "deviceRequired", $$v)
                      },
                      expression: "formData.deviceRequired",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#999",
                        "font-size": "12px",
                        "margin-left": "10px",
                      },
                    },
                    [_vm._v("Requires WeWALK device connection")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Requires V2 Device" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.formData.requiresV2,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "requiresV2", $$v)
                      },
                      expression: "formData.requiresV2",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#999",
                        "font-size": "12px",
                        "margin-left": "10px",
                      },
                    },
                    [_vm._v("Only works with V2 devices")]
                  ),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("Status"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Active" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.formData.isActive,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "isActive", $$v)
                      },
                      expression: "formData.isActive",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#999",
                        "font-size": "12px",
                        "margin-left": "10px",
                      },
                    },
                    [_vm._v("Enable or disable this feature")]
                  ),
                ],
                1
              ),
              _c(
                "el-collapse",
                { staticStyle: { "margin-top": "20px" } },
                [
                  _c(
                    "el-collapse-item",
                    {
                      attrs: {
                        title: "Advanced Settings (JSON)",
                        name: "advanced",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 4,
                              placeholder: '{"customKey": "customValue"}',
                            },
                            model: {
                              value: _vm.formData.configJsonStr,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "configJsonStr", $$v)
                              },
                              expression: "formData.configJsonStr",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#999",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                "Additional configuration will be merged with form values"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveData()
                    },
                  },
                },
                [_vm._v("Confirm")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Feature Details",
            visible: _vm.dialogViewVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogViewVisible = $event
            },
          },
        },
        [
          _c(
            "el-descriptions",
            { attrs: { column: 2, border: "" } },
            [
              _c("el-descriptions-item", { attrs: { label: "ID" } }, [
                _vm._v(_vm._s(_vm.viewData.id)),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Feature Key" } },
                [_c("el-tag", [_vm._v(_vm._s(_vm.viewData.featureKey))])],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Name", span: 2 } },
                [_vm._v(_vm._s(_vm.viewData.name))]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Description", span: 2 } },
                [_vm._v(" " + _vm._s(_vm.viewData.description) + " ")]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Status" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.viewData.isActive ? "success" : "danger",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.viewData.isActive ? "Active" : "Inactive"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Type" } },
                [
                  _vm.viewData.configJson
                    ? _c("el-tag", { attrs: { type: "info" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getTypeLabel(_vm.viewData.configJson.type)
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Default Duration" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.viewData.configJson &&
                          _vm.viewData.configJson.defaultDurationDays
                          ? _vm.viewData.configJson.defaultDurationDays +
                              " days"
                          : "N/A"
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Reminder Days" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.viewData.configJson &&
                          _vm.viewData.configJson.reminderDays
                          ? _vm.viewData.configJson.reminderDays.join(", ") +
                              " days"
                          : "N/A"
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Platforms" } },
                [
                  _vm._l(
                    _vm.viewData.configJson?.platforms || [],
                    function (platform) {
                      return _c(
                        "el-tag",
                        {
                          key: platform,
                          staticStyle: { "margin-right": "5px" },
                          attrs: { size: "small" },
                        },
                        [_vm._v(" " + _vm._s(platform.toUpperCase()) + " ")]
                      )
                    }
                  ),
                  !_vm.viewData.configJson?.platforms?.length
                    ? _c("span", [_vm._v("N/A")])
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Device Required" } },
                [
                  _vm.viewData.configJson &&
                  _vm.viewData.configJson.deviceRequired
                    ? _c("i", {
                        staticClass: "el-icon-check",
                        staticStyle: { color: "green" },
                      })
                    : _c("i", {
                        staticClass: "el-icon-close",
                        staticStyle: { color: "red" },
                      }),
                ]
              ),
              _c("el-descriptions-item", { attrs: { label: "Requires V2" } }, [
                _vm.viewData.configJson && _vm.viewData.configJson.requiresV2
                  ? _c("i", {
                      staticClass: "el-icon-check",
                      staticStyle: { color: "green" },
                    })
                  : _c("i", {
                      staticClass: "el-icon-close",
                      staticStyle: { color: "red" },
                    }),
              ]),
              _c("el-descriptions-item", { attrs: { label: "" } }),
              _c("el-descriptions-item", { attrs: { label: "Created At" } }, [
                _vm._v(
                  " " + _vm._s(_vm.formatDate(_vm.viewData.createdAt)) + " "
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "Updated At" } }, [
                _vm._v(
                  " " + _vm._s(_vm.formatDate(_vm.viewData.updatedAt)) + " "
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-collapse",
            { staticStyle: { "margin-top": "20px" } },
            [
              _c(
                "el-collapse-item",
                { attrs: { title: "Raw Configuration (JSON)", name: "raw" } },
                [
                  _c(
                    "pre",
                    {
                      staticStyle: {
                        background: "#f5f5f5",
                        padding: "10px",
                        "border-radius": "4px",
                        "max-height": "200px",
                        overflow: "auto",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(JSON.stringify(_vm.viewData.configJson, null, 2))
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogViewVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleEdit(_vm.viewData)
                    },
                  },
                },
                [_vm._v("Edit")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }